<div class="planning-slot-popover flex flex-col">
  <rk-mobile-close-button
    [marginTopPx]="-42"
    (click)="closeSelf()"
  ></rk-mobile-close-button>
  <rk-icon-button
    class="planning-slot-popover--close-button hidden md:block"
    faIcon="fa-times"
    color="gray-darkest"
    [size]="26"
    (click)="closeSelf()"
  ></rk-icon-button>
  <div class="planning-slot-popover--title-container">
    <div
      *ngIf="program"
      class="planning-slot-popover--program-color"
      [style.backgroundColor]="program.color"
    ></div>
    <rk-playlist-icon
      *ngIf="playlist"
      class="planning-slot-popover--playlist-color"
      [playlist]="playlist"
    ></rk-playlist-icon>
    <div class="planning-slot-popover--title">{{ event.title }}</div>
  </div>
  <div class="planning-slot-popover--date">{{ formattedDateRange }}</div>
  <div class="planning-slot-popover--playtype">
    <mat-icon
      class="planning-slot-popover--playtype-icon"
      fontSet="fas"
      [fontIcon]="playTypeIcon"
      [inline]="true"
    ></mat-icon>
    <div class="planning-slot-popover--playtype-text">{{ playTypeText | translate }}</div>
  </div>
  <div class="planning-slot-popover--repeat" *ngIf="slotRepeat?.repeatInterval">
    <mat-icon
      class="planning-slot-popover--repeat-icon"
      fontSet="fas"
      fontIcon="fa-redo"
      [inline]="true"
    ></mat-icon>
    <div class="flex flex-col">
      <div class="planning-slot-popover--repeat-text">
        {{ repeatText | translate }}
      </div>
      <div
        class="planning-slot-popover--repeat-weekday text-gray-darkest"
        *ngIf="slotRepeat?.repeatInterval > 1"
      >
        {{ repeatWeekday }}
      </div>
    </div>
  </div>
  <div class="actions mt-4">
    <rk-button
      class="actions-button"
      [fullWidth]="data.mobile"
      [label]="'SCHEDULE.PLANNING.DELETE_SLOT' | translate"
      [btnStyle]="'orangeText'"
      (click)="deletionClicked(event)"
    ></rk-button>
    <rk-button
      class="actions-button"
      [fullWidth]="data.mobile"
      [label]="'SCHEDULE.PLANNING.EDIT_SLOT' | translate"
      (click)="editionClicked(event)"
    ></rk-button>
  </div>
</div>
